import type { FetchError } from 'ofetch';

export const usePermissionsStore = defineStore('permissions', () => {
  const { getAllPermissions } = useApi();
  const permissions = ref<Permission[]>([]);
  const permissionsLoading = ref(false);

  /**
   * Fetches all of the permissions from the server and populates the store.
   * If the `forceRefresh` argument is set to true, then the data is always
   * re-requested. Otherwise, the last retrieved value will be returned if
   * one exists.
   *
   * @param forceRefresh
   */
  const fetchPermissions = async (forceRefresh = false) => {
    if (!forceRefresh && permissions.value.length > 0) {
      return;
    }

    permissionsLoading.value = true;
    try {
      permissions.value = (await getAllPermissions()).results;
    }
    catch (err) {
      console.error('Error fetching permissions:', (err as FetchError).message);
    }
    permissionsLoading.value = false;
  };

  return { permissions, permissionsLoading, fetchPermissions };
});
